// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.inline-container {
  display: flex;
  align-items: center;
  /* opcionális, hogy középre igazítsa a magasságot */
  gap: 8px;
  /* opcionális, kis hézag a mező és a szöveg között */
}

.inline-container mat-form-field {
  flex-shrink: 1;
}

.inline-container span {
  white-space: nowrap;
  /* ne törje sort */
}

.material-consupmption-hr {
  height: 2px;
  background-color: #4f4f4f;
  width: 100%;
  margin: 10px 0;
}

table {
  width: 100%;
}

@media (max-width: 599px) {
  .hw-grid-cell {
    float: right;
    text-align: right;
    font-weight: bold;
    font-size: 14px;
  }
  .hw-mobile-width-80 {
    width: 80%;
  }
  .hw-mobile-width-20 {
    width: 20%;
  }
  .hw-mobile-display-inherit {
    display: flex;
  }
  th.mat-header-cell,
  td.mat-cell,
  td.mat-footer-cell {
    margin-bottom: 1em;
  }
  .boolean-cell {
    font-size: 20px;
  }
  tr.mat-row,
  tr.mat-footer-row {
    height: 48px;
    width: 100%;
  }
  .hw-mobile-table-title-show {
    text-align: left;
  }
  .mdc-data-table__cell,
  .mdc-data-table__header-cell {
    padding: 12px 0px 0 0px;
  }
  .material-consupmption-hr {
    height: 2px;
    background-color: #4f4f4f;
    width: 100%;
    margin: 30px 0px 0px 0px;
  }
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
